<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc1"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">1. How Could You, Mr. McKay?</a></p>
<p class="toc"><a href="#/chapter02">2. A Mouse with a Vision</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. It All Began with Dellinger</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Bradley’s Big Game</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Trail Blazing to a Title</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Recollections of Luke</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Sweet Scent of Roses</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Ralph and the Orange Express</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Legends in Their Own Time</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Pericin and Showtime Hoops</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Maestro of the Giant Killers</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Marking Time with Mark All</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. The Day After the Storm</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. A Long-Overdue Payback</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. Big Mac in a Big Way</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. LPGA: Behind the Scenes</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">17. The Vigil for Eric Ross</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">18. And That’s Entertainment!</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">19. The Fantasy Title Bout</span></p>
<p class="toc"><span href="#/chapter20" title="Link target outside of Sample">20. Memorable Moments</span></p>
<p class="toc1"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?136e397e